import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Heading from '../../../../../components/Atoms/Heading/Heading';
import { Fragment } from 'react';
import { HeadingAlign, HeadingSizeType, } from '../../../../../components/Atoms/Heading/Heading.enum';
import sendGTMEvent from '../../../../common/analytics/sendGTMEvent';
import { StyledHeading } from '../../Autocomplete.styled';
import { StyledBox, StyledBoxContainer, StyledDropdownContent } from './MostPopularSearches.styled';
const staticPopularSearchImgUrl = 'https://assets-static-prod.displate.com/next-assets/public/images/header';
const mostPopularSearchesData = [
    {
        label: 'Star Wars',
        imagePath: `${staticPopularSearchImgUrl}/star_wars`,
    },
    {
        label: 'Harry Potter',
        imagePath: `${staticPopularSearchImgUrl}/harry_potter`,
    },
    {
        label: 'Cyberpunk 2077',
        imagePath: `${staticPopularSearchImgUrl}/cyberpunk2077`,
    },
    {
        label: 'Cars',
        imagePath: `${staticPopularSearchImgUrl}/cars`,
    },
    {
        label: 'Dragon',
        imagePath: `${staticPopularSearchImgUrl}/dragons`,
    },
    {
        label: 'Japan',
        imagePath: `${staticPopularSearchImgUrl}/japan`,
    },
    {
        label: 'Space',
        imagePath: `${staticPopularSearchImgUrl}/space`,
    },
    {
        label: 'Football',
        imagePath: `${staticPopularSearchImgUrl}/football`,
    },
];
export const MostPopularSearchesBoxesConr2659 = ({ handleClick, phrase, hasRecentlySearchItems, }) => {
    const handleOnMostPopularClick = ({ index, item }) => {
        sendGTMEvent({
            event: 'search_perform',
            search_term: item && item.toLowerCase(),
            search_input: phrase ? phrase.toLowerCase() : '(empty_input)',
            search_method: 'recommendation',
            search_category: '',
        });
        handleClick &&
            handleClick({
                searchPhrase: phrase,
                category: '',
                listingFunction: 'most_popular',
                listingType: 'autocomplete',
                phrase: item,
                searchPosition: index,
            });
    };
    const Container = hasRecentlySearchItems ? Fragment : StyledDropdownContent;
    return (_jsxs(Container, { children: [_jsx(StyledHeading, Object.assign({ as: "h5", hasRecentlySearchItems: hasRecentlySearchItems, textSize: HeadingSizeType.TITLE16 }, { children: "See hottest picks" }), void 0), _jsx(StyledBoxContainer, { children: mostPopularSearchesData.map((item, index) => (_jsx(StyledBox, Object.assign({ bgImage: `${item.imagePath}.jpg`, bgImage2x: `${item.imagePath}@2x.jpg`, onClick: () => handleOnMostPopularClick({ index, item: item.label }), role: "link" }, { children: _jsx(Heading, Object.assign({ align: HeadingAlign.CENTER, as: "span", color: "white", textSize: HeadingSizeType.TITLE16 }, { children: item.label }), void 0) }), item.label))) }, void 0)] }, void 0));
};
//# sourceMappingURL=MostPopularSearchesBoxesConr2659.js.map